import { call, put } from "redux-saga/effects";
import { enrollmentApi } from "@services/api";
import { checkEnrollmentActions } from "../slices";
import { getCourseLearningActions } from "@redux/modules/course/slices";

function* checkEnrollmentWorker({ payload }) {
  try {
    yield put(checkEnrollmentActions.pending());
    yield put(getCourseLearningActions.pending());
    const response = yield call(enrollmentApi.checkEnrollment, payload);
    yield put(checkEnrollmentActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(checkEnrollmentActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { checkEnrollmentWorker };
